<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" size="md" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <salary-effect-type-create-or-update v-model="effectType" :errors="errors" :editing="editing"></salary-effect-type-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>

            <b-modal id="create-or-update-period" size="lg" :title="[periodEditing ? 'Periyot Güncelle': 'Periyot Oluştur', effectTypePeriod.SalaryEffectTypeName || null].join(' - ')" no-close-on-esc no-close-on-backdrop>
                <salary-effect-type-create-or-update-period v-model="effectTypePeriod" :errors="errors"></salary-effect-type-create-or-update-period>
                <template #modal-footer><v-executer :loading="loading" :editing="periodEditing" :action="updatePeriod"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        name="salary-effect"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"
                        button-alignment="text-left">
                            <template #filters>
                                <salary-effect-type-filter v-on:filter="filter"></salary-effect-type-filter>
                            </template>
                        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SalaryEffectTypeCreateOrUpdate from './components/SalaryEffectTypeCreateOrUpdate.vue'
import SalaryEffectTypeFilter from './components/SalaryEffectTypeFilter.vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import SalaryEffectTypeCreateOrUpdatePeriod from './components/SalaryEffectTypeCreateOrUpdatePeriod.vue'

export default {
    components:{
        BCard,
        SalaryEffectTypeCreateOrUpdate,
        SalaryEffectTypeCreateOrUpdatePeriod,
        SalaryEffectTypeFilter
    },
    data(){
        return{
            fields:[
                {name:"KYKM Tür Grubu",key:"SalaryEffectTypeGroup.Name", thClass:"w-23"}, 
                {name:"KYKM Türü",key:"Name", thClass:"w-22",sortable:true},   
                {name:"Öncelik",key:"Priority", thClass:"w-11",sortable:true},   
                {name:"Kat Sayı",key:"Multiple", thClass:"w-11"},   
                {name:"Çalışma Gün Türü",key:"EmployeeWorkingType.Name",thClass:'w-11'},  
                // {name:"Netsis",key:"NetsisSync",thClass:'w-11'},  
                {name:"Şube",key:"ActiveBranch.Name", thClass:"w-11",sortable:true},   
                {name:"Hesap Kodu",key:"NetsisPaymentAccountCode", thClass:"w-11",sortable:true},
                {name:"Sistem Kodu",key:"SystemCode", sortable:true},   
                {name:"Etki Yönü",component:true,componentOptions:{name:"salary-effect-type-group-positive-negative/SalaryEffectTypeGroupPositiveNegative"}},
                // {name:"Periyodik",key:"Periodic"},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                // { text:"Periyot",key:"period",icon:"ClockIcon",variant:"success",action:this.period,condition:item=>item.Periodic},
            ],
            editing:false,
            periodEditing:false,
            errors:{},
            loading:false,
            effectType:{
                Id:null,
                Name:null,
                Priority:null,
                SalaryEffectTypeGroupId:null,
                EmployeeWorkingTypeId:null,
                SystemCode:null,
                Multiple:1,
                ActiveBranchId:null,
                NetsisPaymentAccountCode:null,
                Periodic:false,
                Assignable:false,
                Positive:true,
            },
            effectTypePeriod:{
                SalaryEffectTypeId:null,
                SalaryEffectTypeName:null,
                Id:null,
                FirstPaymentDate:null,
                Period:1,
                Monthly:false,
                FirstJobStartDay: null,
                SecondJobStartDay: null,
                LackOfDayTolerance:0,
                BJSFixedAmount :false,
                BJSAmount :null,
                BFSFixedAmount :false,
                BFSAmount :null,
                ASFixedAmount :false,
                ASAmount :null,
            },
            filterData:{
                BranchId:null,
                SalaryEffectTypeGroupId:null
            }
        }
    },
    methods:{
        filter(data){
            this.filterData = data
            this.$refs.table.refresh()
        },
        clearForm(){
            this.editing = false
            this.periodEditing = false
            this.effectType.Id = null
            this.effectType.Name = null
            this.effectType.Priority = null
            this.effectType.SalaryEffectTypeGroupId = null
            this.effectType.EmployeeWorkingTypeId = null
            this.effectType.SystemCode = null
            this.effectType.Multiple = 1
            this.effectType.Periodic = false
            this.effectType.Assignable = false
            this.effectType.NetsisPaymentAccountCode = null
            this.effectType.ActiveBranchId = false
            this.effectType.Positive = true
            this.effectTypePeriod.SalaryEffectTypeId = null
            this.effectTypePeriod.SalaryEffectTypeName = null
            this.effectTypePeriod.Id = null
            this.effectTypePeriod.FirstPaymentDate = null
            this.effectTypePeriod.Period = 1
            this.effectTypePeriod.Monthly = false
            this.effectTypePeriod.FirstJobStartDay = null
            this.effectTypePeriod.SecondJobStartDay = null
            this.effectTypePeriod.LackOfDayTolerance = 0
            this.effectTypePeriod.BJSFixedAmount = false
            this.effectTypePeriod.BJSAmount = null
            this.effectTypePeriod.BFSFixedAmount = false
            this.effectTypePeriod.BFSAmount = null
            this.effectTypePeriod.ASFixedAmount = false
            this.effectTypePeriod.ASAmount = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return HumanResourcesParameterApi.SalaryEffect.Type.Table({
                ...this.filterData,
                PaginationRequest:data
            })
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.effectType.Id = item.Id
            this.effectType.Name = item.Name
            this.effectType.Priority = item.Priority
            this.effectType.SalaryEffectTypeGroupId = item.SalaryEffectTypeGroup?.Id || null
            this.effectType.EmployeeWorkingTypeId = item.EmployeeWorkingType?.Id || null
            this.effectType.SystemCode = item.SystemCode
            this.effectType.Multiple = item.Multiple
            this.effectType.Periodic = item.Periodic
            this.effectType.Assignable = item.Assignable
            this.effectType.Positive = item.Positive
            this.effectType.NetsisPaymentAccountCode = item.NetsisPaymentAccountCode
            this.effectType.ActiveBranchId = item?.ActiveBranch?.Id || null
            this.$showModal('create-or-update')
        },
        period(item){
            this.clearForm()
            if(item.Period != null){
                this.periodEditing = true
                this.effectTypePeriod.Id = item.Period?.Id || null
                this.effectTypePeriod.FirstPaymentDate = item.Period?.FirstPaymentDate || null
                this.effectTypePeriod.Period = item.Period?.Period || 1
                this.effectTypePeriod.Monthly = item.Period?.Monthly || false
                this.effectTypePeriod.FirstJobStartDay = item.Period?.FirstJobStartDay || null
                this.effectTypePeriod.SecondJobStartDay = item.Period?.SecondJobStartDay || null
                this.effectTypePeriod.LackOfDayTolerance = item.Period?.LackOfDayTolerance || 0
                this.effectTypePeriod.BJSFixedAmount = item.Period?.BJSFixedAmount || false
                this.effectTypePeriod.BJSAmount = item.Period?.BJSAmount || null
                this.effectTypePeriod.BFSFixedAmount = item.Period?.BFSFixedAmount || false
                this.effectTypePeriod.BFSAmount = item.Period?.BFSAmount || null
                this.effectTypePeriod.ASFixedAmount = item.Period?.ASFixedAmount || false
                this.effectTypePeriod.ASAmount = item.Period?.ASAmount || null
            }
            this.effectTypePeriod.SalaryEffectTypeId = item.Id
            this.effectTypePeriod.SalaryEffectTypeName = item.Name
            this.$showModal('create-or-update-period')
        },
        updatePeriod(){
            this.loading = true
            HumanResourcesParameterApi.SalaryEffect.Type.Period.CreateOrUpdate(this.periodEditing,this.effectTypePeriod).then(res=>{
                this.loading = false
                this.$result(res)
                if(res.data.Success){
                    this.$refs.table.refresh()
                    this.$hideModal('create-or-update-period')
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        createOrUpdate(){
            this.loading = true
            HumanResourcesParameterApi.SalaryEffect.Type.CreateOrUpdate(this.editing,this.effectType).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} KYKM türünü silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    HumanResourcesParameterApi.SalaryEffect.Type.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>